import moment from 'moment';
import { Options, Vue } from 'vue-class-component';
import { Inject, Prop, Watch } from 'vue-property-decorator';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';

@Options({
  mixins: [FormatDateTimeMixin]
})
export default class DateController extends Vue {

  private currentDate = moment(new Date);
  private currentDateDisplay = moment(new Date).format('MMMM YYYY');
  private calendarView = '3'; // monthly view by default; 1: day, 2: week, 3: month
  private currentDatePeriodStart = "";
  private currentDatePeriodEnd = "";



  @Watch('calendarView')
  onCalendarViewChanged(): void {
    this.updateDisplay();
  }

  mounted(): void {
    this.getTimePeriod();
  }

  private getTimePeriod(): void {
    switch (this.calendarView) {
      case '1':
        this.currentDatePeriodStart = moment(this.currentDate).startOf('day').format();
        this.currentDatePeriodStart = moment(this.currentDatePeriodStart).utc().format();
        this.currentDatePeriodEnd = moment(this.currentDate).endOf('day').format();
        this.currentDatePeriodEnd = moment(this.currentDatePeriodEnd).utc().format();
        break;
      case '2':
        this.currentDatePeriodStart = moment(this.currentDate).startOf('week').format();
        this.currentDatePeriodStart = moment(this.currentDatePeriodStart).utc().format();
        this.currentDatePeriodEnd = moment(this.currentDate).endOf('week').format();
        this.currentDatePeriodEnd = moment(this.currentDatePeriodEnd).utc().format();
        break;
      case '3':
        this.currentDatePeriodStart = moment(this.currentDate).startOf('month').format();
        this.currentDatePeriodStart = moment(this.currentDatePeriodStart).utc().format();
        this.currentDatePeriodEnd = moment(this.currentDate).endOf('month').format();
        this.currentDatePeriodEnd = moment(this.currentDatePeriodEnd).utc().format();
        break;
    }

    this.$emit('getTimePeriod', {
      startDatePeriod: this.currentDatePeriodStart,
      endDatePeriod: this.currentDatePeriodEnd
    })
  }

  private prev() {
    switch (this.calendarView) {
      case '1':
        this.currentDate = moment(this.currentDate).subtract(1, 'day');
        break;
      case '2':
        this.currentDate = moment(this.currentDate).subtract(1, 'week');
        break;
      case '3':
        this.currentDate = moment(this.currentDate).subtract(1, 'months');
        break;
    }
    this.$emit('prev', this.currentDate);
    this.updateDisplay();
  }

  private next() {
    switch (this.calendarView) {
      case '1':
        this.currentDate = moment(this.currentDate).add(1, 'day');
        break;
      case '2':
        this.currentDate = moment(this.currentDate).add(1, 'week');
        break;
      case '3':
        this.currentDate = moment(this.currentDate).add(1, 'months');
        break;
    }
    this.$emit('next', this.currentDate);
    this.updateDisplay();
  }

  private today() {
    // this.calendarView = '1';
    this.currentDate = moment(new Date());
    this.$emit('today', {
      calendarView: this.calendarView,
      currentDate: this.currentDate
    })
    this.updateDisplay();
  }

  private updateDisplay() {
    const _from_date = moment(this.currentDate).startOf('week');
    const _to_date = moment(this.currentDate).endOf('week');
    switch (this.calendarView) {
      case '1':
        this.currentDateDisplay = moment(this.currentDate).format('dddd, DD MMM YYYY');
        break;
      case '2':
        this.currentDateDisplay = _from_date.format('DD MMM') + ' - ' + _to_date.format('DD MMM YYYY');
        break;
      case '3':
        this.currentDateDisplay = moment(this.currentDate).format('MMMM YYYY');
        break;
    }
    this.$emit('update', this.currentDateDisplay);
    this.getTimePeriod();
  }
}
